function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBusinessAndEconomics = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 42 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M37.192,1.332C37.422,1.57 37.599,1.838 37.721,2.122C37.844,2.406 37.906,2.72 37.906,3.058L37.906,10.428C37.906,11.786 36.809,12.883 35.451,12.883C34.094,12.883 32.997,11.786 32.997,10.428L32.997,8.994L24.913,17.07C24.008,17.975 22.551,18.037 21.577,17.201L14.59,11.203L7.595,17.201C6.568,18.083 5.018,17.96 4.136,16.932C3.254,15.904 3.377,14.355 4.405,13.473L12.995,6.11C13.915,5.32 15.273,5.32 16.193,6.11L23.057,11.993L29.523,5.52L28.088,5.52C26.731,5.52 25.634,4.423 25.634,3.065C25.634,1.708 26.731,0.611 28.088,0.611L35.451,0.611C36.126,0.611 36.74,0.887 37.185,1.324L37.192,1.332ZM1.091,23.927C1.091,21.894 2.74,20.245 4.773,20.245L36.678,20.245C38.711,20.245 40.36,21.894 40.36,23.927L40.36,36.198C40.36,38.231 38.711,39.88 36.678,39.88L4.773,39.88C2.74,39.88 1.091,38.231 1.091,36.198L1.091,23.927ZM4.773,32.517L4.773,36.198L8.454,36.198C8.454,34.166 6.805,32.517 4.773,32.517ZM8.454,23.927L4.773,23.927L4.773,27.608C6.805,27.608 8.454,25.959 8.454,23.927ZM36.678,32.517C34.646,32.517 32.997,34.166 32.997,36.198L36.678,36.198L36.678,32.517ZM32.997,23.927C32.997,25.959 34.646,27.608 36.678,27.608L36.678,23.927L32.997,23.927ZM25.634,30.062C25.634,27.355 23.433,25.154 20.726,25.154C18.018,25.154 15.817,27.355 15.817,30.062C15.817,32.77 18.018,34.971 20.726,34.971C23.433,34.971 25.634,32.77 25.634,30.062Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBusinessAndEconomics);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/business-and-economics.41030db10611d178d5986d3a6b8d0891.svg";